import './ProductsListPage.css';

import React, { useRef } from 'react';
import { Box } from '@mui/material';
import Banner from '../../b2b-common/Banner';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import ProductsHierarchy from '../components/products/ProductsHierarchy';
import CustomButton from '../../b2b-common/CustomButton';
import { AddCircleOutline } from '@mui/icons-material';
import ProductEditForm from '../forms/ProductEditForm';

const ProductsListPage = () => {
    const { t } = useB2BTranslation('b2b-users');
    const [showProductEditForm, setShowProductEditForm] = React.useState(false);
    const [productSelected, setProductSelected] = React.useState(null);

    const handleNewProduct = () => {
        setProductSelected(null);
        setShowProductEditForm(true);
    };

    const handleProductSelected = (product) => {
        setProductSelected(product);
        setShowProductEditForm(true);
    };

    const productsHierarchyRef = useRef();

    const handleProductSaved = (product) => {
        setShowProductEditForm(false);
        if (productsHierarchyRef.current) {
            productsHierarchyRef.current.triggerRefresh();
        }
    }

    const handleProductDeleted = () => {
        setShowProductEditForm(false);
        if (productsHierarchyRef.current) {
            productsHierarchyRef.current.triggerRefresh();
        }
    }

    return (
        <Box className="products-list-page" gap={3}>
            <CustomButton label={t('New Product')} className='products-list-page-new-product-button white_02'
                icon={<AddCircleOutline />}
                rolesAllowed={['SUPER-ADMIN']} confirm={false}
                onClick={handleNewProduct}
            />
            <Banner sectionTittle={t('Users Menu')} message={t('List available products')} underline={false} />
            <Box className={'products-list-and-product-details'} gap={3} width={'100%'} display={'flex'} >
                <ProductsHierarchy ref={productsHierarchyRef} styles={{container: {width: '30%'}}} onProductSelect={handleProductSelected} />
                <Box className={'product-details'} gap={3} width={'70%'} display={'flex'} >
                    <ProductEditForm
                        showForm={showProductEditForm} product={productSelected}
                        onSave={handleProductSaved}
                        onDelete={handleProductDeleted}
                        onCancel={() => setShowProductEditForm(false)}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default ProductsListPage;